import { Card, CardContent, Text } from '@shared/ui';
import { cn } from '@shared/lib/utils';

interface ColorSwatchProps {
  label: string;
  className: string;
}

export function ColorSwatch({ label, className }: ColorSwatchProps) {
  return (
    <Card className="overflow-hidden">
      <div className={cn('h-14 w-full border-b border-border', className)} />
      <CardContent className="p-3">
        <Text size="sm" className="font-medium">
          {label}
        </Text>
      </CardContent>
    </Card>
  );
}
